module.exports = __webpack_public_path__ + "static/media/bannerIntro.c2dd07b2.jpg";